import React from "react";
import CountUp from "react-countup";

// Composant graphique pour afficher un Counter.
// Composant "dumb", fait juste afficher un count animé
// en fonction de props.data.
const Counter = (props) => {
  var { data, units } = props;
  if (typeof data === "undefined" || data === null || isNaN(data)) {
    return <span className="counter-wrap">0{units && <small>{units}</small>}</span>;
  }

  return (
    <span className="counter-wrap">
      <CountUp separator=" " decimal="," end={data} preserveValue />
      {units && <small>{units}</small>}
    </span>
  );
};

export default Counter;
